import { Alert, Container, Stack, Typography } from "@mui/material";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { InvestorChangeRequestDetails } from "../../../../api/types/workflowTypes";
import ApprovalWidget from "../../../approvals/ApprovalWidget";
import { isV2ChangeRequest } from "../changeRequestsFormatters";
import ChangeRequestInfoSection from "./ChangeRequestInfoSection";
import InvestorChangeRequestDetailsSection from "./InvestorChangeRequestDetailsSection";
import MembersChangeRequestDetailsSection from "./members/MembersChangeRequestDetailsSection";

interface Props {
  changeRequestDetails: InvestorChangeRequestDetails;
  onApprovalActionExecuted: () => void;
}

const ChangeRequestDetailsSection = ({ changeRequestDetails, onApprovalActionExecuted }: Props) => {
  const isMembersChangeRequest = changeRequestDetails.workflowType === "MembersChangeRequest";

  return (
    <Container>
      <Stack spacing={5} sx={{ py: 2.5 }}>
        {isV2ChangeRequest(changeRequestDetails) && (
          <ApprovalWidget
            approvalId={defined(changeRequestDetails.approvalId)}
            requestOrigin={{
              requestedByUserName: changeRequestDetails.requestedByUserName,
              requestedAt: changeRequestDetails.requestedAt,
            }}
            onApprovalActionExecuted={onApprovalActionExecuted}
            hideSecondaryActions
          />
        )}

        <ChangeRequestInfoSection changeRequestDetails={changeRequestDetails} />

        {changeRequestDetails.workflowStatus === "Failed" && changeRequestDetails.failureMessage && (
          <Stack spacing={1}>
            <Typography variant="subtitle2">Failure Reason</Typography>
            <Alert severity="error" icon={false} sx={{ ".MuiAlert-message": { whiteSpace: "break-spaces" } }}>
              {changeRequestDetails.failureMessage}
            </Alert>
          </Stack>
        )}
        {changeRequestDetails.workflowStatus === "Rejected" && changeRequestDetails.statusChangeComment && (
          <Stack spacing={1}>
            <Typography variant="subtitle2">Rejection Reason</Typography>
            <Alert severity="error" icon={false} sx={{ ".MuiAlert-message": { whiteSpace: "break-spaces" } }}>
              {changeRequestDetails.statusChangeComment}
            </Alert>
          </Stack>
        )}

        {isMembersChangeRequest ? (
          <MembersChangeRequestDetailsSection changeRequestDetails={changeRequestDetails} />
        ) : (
          <InvestorChangeRequestDetailsSection changeRequestDetails={changeRequestDetails} />
        )}
      </Stack>
    </Container>
  );
};

export default ChangeRequestDetailsSection;
